import { utcToZonedTime } from 'date-fns-tz';
import { useRef } from 'react';

import useTimeZone from '@swf/core/hooks/useTimeZone';

const useGetCurrentDate = (date = new Date(), isRelative?: boolean) => {
  const { timeZoneName, timeZone } = useTimeZone();
  const zonedDate = utcToZonedTime(date.toISOString(), timeZoneName);
  const { current: now } = useRef(zonedDate);

  return { now: isRelative ? zonedDate : now, timeZoneName, timeZone };
};

export default useGetCurrentDate;
